import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {
    getTranslateMessageEventId,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";

export default class CopilotTranslateMessageResponse extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "copilotTranslateMessageResponse";
    }

    public async receive(payload: CometOperatorApplication.CopilotTranslateMessageResponseCometMessageOpenApiModel) {
        OperatorApplicationEventManager.emit(
            getTranslateMessageEventId(payload.messageId),
            payload.patch
        );
    }
}